var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleRightChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.59L4.58 6L0 1.41L1.41 0L7.41 6L1.41 12L0 10.59Z",
    fill: "#A7AABD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.59L10.58 6L6 1.41L7.41 0L13.41 6L7.41 12L6 10.59Z",
    fill: "#A7AABD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleRightChevron);
export default __webpack_public_path__ + "static/media/double_rightChevron.c6a293bfba3fcb1a4ca11296467be88a.svg";
export { ForwardRef as ReactComponent };